import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { GetTagsRequest } from '../../ts/ServerApi/requests/GetTagsRequest';
import { ITag } from '../../ts/ServerApi/types/ITag';

export class TagsResource implements IListResource<ITag> {
  private listFetcher = new WebClientListResourceFetcher(GetTagsRequest, result => result.tags);

  public all(): ResourceQuery<ITag> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const Tags = new TagsResource();
